import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

//import middleware
import auth from "@/middleware/auth";
import guest from "@/middleware/guest";
import permission from "../middleware/permission";

let examplesMenu = {
    path: "/examples",
    component: DashboardLayout,
    name: "Examples",
    children: [{
            path: "role-management/list-roles",
            name: "List Roles",
            component: () =>
                import ( /* webpackChunkName: "list-roles" */ "@/pages/Dashboard/Examples/RoleManagement/ListRolePage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "role-management/add-role",
            name: "Add Role",
            component: () =>
                import ( /* webpackChunkName: "add-role" */ "@/pages/Dashboard/Examples/RoleManagement/AddRolePage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "role-management/edit-role/:id",
            name: "Edit Role",
            component: () =>
                import ( /* webpackChunkName: "edit-role" */ "@/pages/Dashboard/Examples/RoleManagement/EditRolePage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "user-management/list-users",
            name: "List Users",
            component: () =>
                import ( /* webpackChunkName: "list-users" */ "@/pages/Dashboard/Examples/UserManagement/ListUserPage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "user-management/add-user",
            name: "Add User",
            component: () =>
                import ( /* webpackChunkName: "add-user" */ "@/pages/Dashboard/Examples/UserManagement/AddUserPage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "user-management/edit-user/:id",
            name: "Edit User",
            component: () =>
                import ( /* webpackChunkName: "edit-user" */ "@/pages/Dashboard/Examples/UserManagement/EditUserPage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "category-management/list-categories",
            name: "List Categories",
            component: () =>
                import ( /* webpackChunkName: "list-categories" */ "@/pages/Dashboard/Examples/CategoryManagement/ListCategoryPage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "category-management/add-category",
            name: "Add Category",
            component: () =>
                import ( /* webpackChunkName: "add-category" */ "@/pages/Dashboard/Examples/CategoryManagement/AddCategoryPage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "category-management/edit-category/:id",
            name: "Edit Category",
            component: () =>
                import ( /* webpackChunkName: "edit-category" */ "@/pages/Dashboard/Examples/CategoryManagement/EditCategoryPage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "tag-management/list-tags",
            name: "List Tags",
            component: () =>
                import ( /* webpackChunkName: "list-tags" */ "@/pages/Dashboard/Examples/TagManagement/ListTagPage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "tag-management/add-tag",
            name: "Add Tag",
            component: () =>
                import ( /* webpackChunkName: "add-tag" */ "@/pages/Dashboard/Examples/TagManagement/AddTagPage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "tag-management/edit-tag/:id",
            name: "Edit Tag",
            component: () =>
                import ( /* webpackChunkName: "edit-tag" */ "@/pages/Dashboard/Examples/TagManagement/EditTagPage"),
            meta: { middleware: auth }
        },
        {
            path: "item-management/list-items",
            name: "List Items",
            component: () =>
                import ( /* webpackChunkName: "list-items" */ "@/pages/Dashboard/Examples/ItemManagement/ListItemPage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "item-management/add-item",
            name: "Add Item",
            component: () =>
                import ( /* webpackChunkName: "add-item" */ "@/pages/Dashboard/Examples/ItemManagement/AddItemPage.vue"),
            meta: { middleware: auth }
        },
        {
            path: "item-management/edit-item/:id",
            name: "Edit Item",
            component: () =>
                import ( /* webpackChunkName: "edit-item" */ "@/pages/Dashboard/Examples/ItemManagement/EditItemPage"),
            meta: { middleware: auth }
        },
    ]
};

let pagesMenu = {
    path: "/pages",
    component: DashboardLayout,
    name: "Pages",
    redirect: "/pages/user",
    children: [{
            path: "user",
            name: "User Page",
            component: () =>
                import ( /* webpackChunkName: "user" */ "@/pages/Dashboard/Pages/UserProfile.vue"),
            meta: { middleware: auth }
        },
        {
            path: "timeline",
            name: "Timeline Page",
            component: () =>
                import ( /* webpackChunkName: "timeline" */ "@/pages/Dashboard/Pages/TimeLinePage.vue"),
            meta: { middleware: auth }
        }
    ]
};

let customersMenu = {
    path: "/customers",
    component: DashboardLayout,
    name: "Customers",
    children: [{
            path: "list-customers",
            name: "List Customers",
            component: () =>
                import ( /* webpackChunkName: "list-customers" */ "@/pages/Dashboard/Customers/ListCustomerPage.vue"),
            meta: { middleware: auth, title: 'Kontrahenci' }
        },
        {
            path: "add-customer",
            name: "Add Customer",
            component: () =>
                import ( /* webpackChunkName: "add-customers" */ "@/pages/Dashboard/Customers/AddCustomerPage.vue"),
            meta: { middleware: auth, title: 'Dodaj kontrahenta' }
        },
        {
            path: "edit-customer/:id",
            name: "Edit Customer",
            component: () =>
                import ( /* webpackChunkName: "edit-customers" */ "@/pages/Dashboard/Customers/EditCustomerPage.vue"),
            meta: { middleware: auth, title: 'Edytuj kontrahenta' }
        }
    ]
};

let locationsMenu = {
    path: "/locations",
    component: DashboardLayout,
    name: "Locations",
    children: [{
            path: "list-locations",
            name: "List Locations",
            component: () =>
                import ( /* webpackChunkName: "list-locations" */ "@/pages/Dashboard/Locations/ListLocationPage.vue"),
            meta: { middleware: auth, title: 'Lokalizacje' }
        },
        {
            path: "view-location/:id",
            name: "View Location",
            component: () =>
                import ( /* webpackChunkName: "view-location" */ "@/pages/Dashboard/Locations/ViewLocationPage.vue"),
            meta: { middleware: auth, title: 'Szczegóły lokalizacji' }
        },
        {
            path: "add-location",
            name: "Add Location",
            component: () =>
                import ( /* webpackChunkName: "add-locations" */ "@/pages/Dashboard/Locations/AddLocationPage.vue"),
            meta: { middleware: auth, title: 'Dodaj lokalizację' }
        },
        {
            path: "edit-location/:id",
            name: "Edit Location",
            component: () =>
                import ( /* webpackChunkName: "edit-locations" */ "@/pages/Dashboard/Locations/EditLocationPage.vue"),
            meta: { middleware: auth, title: 'Edytuj lokalizację' }
        }
    ]
};

let licencesMenu = {
    path: "/licences",
    component: DashboardLayout,
    name: "Licences",
    children: [{
        path: "list-licences",
        name: "List Licences",
        component: () =>
            import ( /* webpackChunkName: "list-licences" */ "@/pages/Dashboard/Licences/ListLicencePage.vue"),
        meta: { middleware: auth, title: 'Licencje' }
    }]
};

let devicesMenu = {
    path: "/devices",
    component: DashboardLayout,
    name: "devices",
    children: [{
            path: "list-devices",
            name: "List Devices",
            component: () =>
                import ( /* webpackChunkName: "list-devices" */ "@/pages/Dashboard/Devices/ListDevicePage.vue"),
            meta: { middleware: auth, title: 'Urządzenia' }
        },
        {
            path: "view-device/:id",
            name: "View Device",
            component: () =>
                import ( /* webpackChunkName: "view-device" */ "@/pages/Dashboard/Devices/ViewDevicePage.vue"),
            meta: { middleware: auth, title: 'Szczegóły urządzenia' }
        },
        {
            path: "fiscalize/:id",
            name: "Fiscalize Device",
            component: () =>
                import ( /* webpackChunkName: "fiscalize-device-main" */ "@/pages/Dashboard/Devices/Fiscalization/BasicFiscalizePage.vue"),
            meta: { middleware: auth, title: 'Fiskalizacja urządzenia' }
        },
        {
            path: "fiscalize-vat/:id",
            name: "Fiscalize Device VAT",
            component: () =>
                import ( /* webpackChunkName: "fiscalize-device-vat" */ "@/pages/Dashboard/Devices/Fiscalization/VatFiscalizePage.vue"),
            meta: { middleware: auth, title: 'Fiskalizacja urządzenia' }
        },
        {
            path: "fiscalize-header/:id",
            name: "Fiscalize Device Header",
            component: () =>
                import ( /* webpackChunkName: "fiscalize-device-header" */ "@/pages/Dashboard/Devices/Fiscalization/HeaderFiscalizePage.vue"),
            meta: { middleware: auth, title: 'Fiskalizacja urządzenia' }
        },
        {
            path: "fiscalize-header-validation/:id",
            name: "Fiscalize Device Header Validation",
            component: () =>
                import ( /* webpackChunkName: "fiscalize-device-header-validation" */ "@/pages/Dashboard/Devices/Fiscalization/HeaderValidationFiscalizePage.vue"),
            meta: { middleware: auth, title: 'Fiskalizacja urządzenia' }
        },
        {
            path: "licence-freeing/:id",
            name: "Freeing Licence",
            component: () =>
                import ( /* webpackChunkName: "licence-freeing" */ "@/pages/Dashboard/Devices/LicenceFreeing.vue"),
            meta: { middleware: auth, title: 'Awaryjne zamknięcie kasy' }
        },
        {
            path: "licence-freeing-summary/:id",
            name: "Freeing Licence Summary",
            component: () =>
                import ( /* webpackChunkName: "licence-freeing-summary" */ "@/pages/Dashboard/Devices/LicenceFreeing/SummaryPage.vue"),
            meta: { middleware: auth, title: 'Awaryjne zamknięcie kasy' }
        }
    ]
};

let cashRegistersMenu = {
    path: "/cash-registers",
    component: DashboardLayout,
    name: "Cash Registers",
    children: [{
            path: "list-cash-registers",
            name: "List Cash Registers",
            component: () =>
                import ( /* webpackChunkName: "list-cash-registers" */ "@/pages/Dashboard/CashRegisters/ListCashRegisterPage.vue"),
            meta: { middleware: auth, title: 'Kasy fiskalne' }
        },
        {
            path: "view-cash-register/:id",
            name: "View Cash Register",
            component: () =>
                import ( /* webpackChunkName: "view-cash-register" */ "@/pages/Dashboard/CashRegisters/ViewCashRegisterPage.vue"),
            meta: { middleware: auth, title: 'Szczegóły kasy fiskalnej' }
        },
        {
            path: "add-cash-register",
            name: "Add Cash Register",
            component: () =>
                import ( /* webpackChunkName: "add-cash-register" */ "@/pages/Dashboard/CashRegisters/AddCashRegisterPage.vue"),
            meta: { middleware: auth, title: 'Dodaj kasę fiskalną' }
        },
        {
            path: "edit-cash-register/:id",
            name: "Edit Cash Register",
            component: () =>
                import ( /* webpackChunkName: "edit-cash-register" */ "@/pages/Dashboard/CashRegisters/EditCashRegisterPage.vue"),
            meta: { middleware: auth, title: 'Edytuj kasę fiskalną' }
        },
        {
            path: "fiscalization/:id",
            name: "Fiscalization Cash Register",
            component: () =>
                import ( /* webpackChunkName: "fiscalization-cash-register" */ "@/pages/Dashboard/CashRegisters/FiscalizationCashRegisterPage.vue"),
            meta: { middleware: auth, title: 'Fiskalizacja kasy wirtualnej' }
        },
        {
            path: "proposal-virtual-cash-deregistering/:id",
            name: "Proposal Virtual Cash Register Deregistering",
            component: () =>
                import ( /* webpackChunkName: "proposal-virtual-cash-deregistering" */ "@/pages/Dashboard/CashRegisters/ProposalVirtualCashRegisterDeregisteringPage.vue"),
            meta: { middleware: auth, title: 'Wniosek do US o wyrejestrowanie kasy wirtualnej' }
        }
    ]
};

let peopleMenu = {
    path: "/people",
    component: DashboardLayout,
    name: "People",
    children: [{
            path: "list-people",
            name: "List People",
            component: () =>
                import ( /* webpackChunkName: "list-people" */ "@/pages/Dashboard/People/ListPeoplePage.vue"),
            meta: { middleware: auth, title: 'Osoby' }
        },
        {
            path: "add-person",
            name: "Add Person",
            component: () =>
                import ( /* webpackChunkName: "add-people" */ "@/pages/Dashboard/People/AddPersonPage.vue"),
            meta: { middleware: auth, title: 'Dodaj Osobę' }
        },
        {
            path: "edit-person/:id",
            name: "Edit Person",
            component: () =>
                import ( /* webpackChunkName: "edit-people" */ "@/pages/Dashboard/People/EditPersonPage.vue"),
            meta: { middleware: auth, title: 'Edytuj Osobę' }
        }
    ]
};

let servicesMenu = {
    path: "/services",
    component: DashboardLayout,
    name: "Services",
    children: [{
            path: "list-services",
            name: "List Services",
            component: () =>
                import ( /* webpackChunkName: "list-services" */ "@/pages/Dashboard/Services/ListServicePage.vue"),
            meta: { middleware: auth, title: 'Usługi' }
        },
        {
            path: "view-service/:id",
            name: "View Service",
            component: () =>
                import ( /* webpackChunkName: "view-service" */ "@/pages/Dashboard/Services/ViewServicePage.vue"),
            meta: { middleware: auth, title: 'Szczegóły usługi' }
        },
        {
            path: "add-service",
            name: "Add Service",
            component: () =>
                import ( /* webpackChunkName: "add-service" */ "@/pages/Dashboard/Services/AddServicePage.vue"),
            meta: { middleware: auth, title: 'Dodaj usługę' }
        },
        {
            path: "edit-service/:id",
            name: "Edit Service",
            component: () =>
                import ( /* webpackChunkName: "edit-service" */ "@/pages/Dashboard/Services/EditServicePage.vue"),
            meta: { middleware: auth, title: 'Edytuj usługę' }
        }
    ]
};

let DeviceModelFirmwareVersionsMenu = {
    path: "/device-model-firmware-versions",
    component: DashboardLayout,
    name: "Device Model Firmware Versions",
    children: [{
            path: "list-device-model-firmware-versions",
            name: "List Device Model Firmware Versions",
            component: () =>
                import ( /* webpackChunkName: "list-device-model-firmware-versions" */ "@/pages/Dashboard/DeviceModelFirmwareVersions/ListDeviceModelFirmwareVersionPage.vue"),
            meta: { middleware: auth, title: 'Modele urządzeń - wersje oprogramowania' }
        },
        {
            path: "view-device-model-firmware-version/:id",
            name: "View Device Model Firmware Version",
            component: () =>
                import ( /* webpackChunkName: "view-device-model-firmware-version" */ "@/pages/Dashboard/DeviceModelFirmwareVersions/ViewDeviceModelFirmwareVersionPage.vue"),
            meta: { middleware: auth, title: 'Szczegóły wersji' }
        },
        {
            path: "add-device-model-firmware-version",
            name: "Add Device Model Firmware Version",
            component: () =>
                import ( /* webpackChunkName: "add-device-model-firmware-version" */ "@/pages/Dashboard/DeviceModelFirmwareVersions/AddDeviceModelFirmwareVersionPage.vue"),
            meta: { middleware: auth, title: 'Dodaj wersję' }
        },
        {
            path: "edit-device-model-firmware-version/:id",
            name: "Edit Device Model Firmware Version",
            component: () =>
                import ( /* webpackChunkName: "edit-device-model-firmware-version" */ "@/pages/Dashboard/DeviceModelFirmwareVersions/EditDeviceModelFirmwareVersionPage.vue"),
            meta: { middleware: auth, title: 'Edytuj wersję' }
        }
    ]
};

let DeviceFirmwareVersionsMenu = {
    path: "/device-firmware-versions",
    component: DashboardLayout,
    name: "Device Firmware Versions",
    children: [{
            path: "list-device-firmware-versions",
            name: "List Device Firmware Versions",
            component: () =>
                import ( /* webpackChunkName: "list-device-firmware-versions" */ "@/pages/Dashboard/DeviceFirmwareVersions/ListDeviceFirmwareVersionPage.vue"),
            meta: { middleware: auth, title: 'Urządzenia - wersje oprogramowania' }
        },
        {
            path: "view-device-firmware-version/:id",
            name: "View Device Firmware Version",
            component: () =>
                import ( /* webpackChunkName: "view-device-firmware-version" */ "@/pages/Dashboard/DeviceFirmwareVersions/ViewDeviceFirmwareVersionPage.vue"),
            meta: { middleware: auth, title: 'Szczegóły wersji' }
        },
        {
            path: "add-device-firmware-version",
            name: "Add Device Firmware Version",
            component: () =>
                import ( /* webpackChunkName: "add-device-firmware-version" */ "@/pages/Dashboard/DeviceFirmwareVersions/AddDeviceFirmwareVersionPage.vue"),
            meta: { middleware: auth, title: 'Dodaj wersję' }
        },
        {
            path: "edit-device-firmware-version/:id",
            name: "Edit Device Firmware Version",
            component: () =>
                import ( /* webpackChunkName: "edit-device-firmware-version" */ "@/pages/Dashboard/DeviceFirmwareVersions/EditDeviceFirmwareVersionPage.vue"),
            meta: { middleware: auth, title: 'Edytuj wersję' }
        }
    ]
};

let DeviceModelsMenu = {
    path: "/device-models",
    component: DashboardLayout,
    name: "Device Models",
    children: [{
            path: "list-device-models",
            name: "List Device Models",
            component: () =>
                import ( /* webpackChunkName: "list-device-models" */ "@/pages/Dashboard/DeviceModels/ListDeviceModelPage.vue"),
            meta: { middleware: auth, title: 'Modele urządzeń' }
        }
    ]
};

let personalTokensMenu = {
    path: "/oauth",
    component: DashboardLayout,
    name: "Personal Tokens",
    children: [{
            path: "personal-tokens",
            name: "List Personal Tokens",
            component: () =>
                import ( /* webpackChunkName: "list-personal-tokens" */ "@/pages/Dashboard/PersonalTokens/PersonalTokens.vue"),
            meta: { 
                middleware: [auth, permission], 
                permission: 'manage personal tokens',
                title: 'Tokeny osobiste'
            }
        },
        {
            path: "personal-tokens/add",
            name: "Add Personal Token",
            component: () =>
                import ( /* webpackChunkName: "add-personal-token" */ "@/pages/Dashboard/PersonalTokens/AddToken.vue"),
            meta: { 
                middleware: [auth, permission], 
                permission: 'manage personal tokens',
                title: 'Dodaj token'
            }
        }
    ]
};

let authPages = {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    children: [{
            path: "/login",
            name: "Login",
            component: () =>
                import ( /* webpackChunkName: "login" */ "@/pages/Dashboard/Pages/Login.vue"),
            meta: { middleware: guest }
        },
        // {
        //     path: "/register",
        //     name: "Register",
        //     component: () =>
        //        import ( /* webpackChunkName: "register-default" */ "@/pages/Dashboard/Pages/Register.vue"),
        //     meta: { middleware: guest }
        // },
        {
            path: "/email-not-verified/:email",
            name: "Email Not Verified",
            component: () =>
                import ( /* webpackChunkName: "email-not-verified" */ "@/pages/Dashboard/Pages/EmailNotVerified.vue"),
            meta: { middleware: guest, title: 'Adres e-mail nie został zweryfikowany' }
        },
        {
            path: "/account-activate/:id/:expires/:hash/:signature",
            name: "Aktywacja konta",
            component: () =>
                import ( /* webpackChunkName: "account-activate" */ "@/pages/Dashboard/Pages/AccountActivate.vue"),
            meta: { middleware: guest, title: 'Aktywacja konta' }
        },
        // {
        //     path: "/account-activate-old/:id/:expires/:hash/:signature",
        //     name: "Aktywacja konta OLD",
        //     component: () =>
        //         import ( /* webpackChunkName: "account-activate-old" */ "@/pages/Dashboard/Pages/AccountActivateOld.vue"),
        //     meta: { middleware: guest, title: 'Aktywacja konta Old' }
        // },
        {
            path: "/password-forgot",
            name: "Password Forgot",
            component: () =>
                import ( /* webpackChunkName: "password-forgot" */ "@/pages/Dashboard/Pages/UserPasswordForgot.vue"),
            meta: { middleware: guest, title: 'Nie pamiętasz hasła' }
        },
        {
            path: "/password-reset/:token/:email",
            name: "Reset hasła",
            component: () =>
                import ( /* webpackChunkName: "password-reset" */ "@/pages/Dashboard/Pages/UserPasswordReset.vue"),
            meta: { middleware: guest, title: 'Reset hasła' }
        },
        // //Rejestracja firmy i konta użytkownika
        // {
        //     path: "/register",
        //     name: "Rejestracja",
        //     component: () =>
        //         import ( /* webpackChunkName: "register" */ "@/pages/Dashboard/Pages/RegisterWizard.vue"),
        //     meta: { middleware: guest, title: 'Rejestracja' }
        // },
        // {
        //     path: "/pricing",
        //     name: "Pricing",
        //     component: () =>
        //         import ( /* webpackChunkName: "pricing" */ "@/pages/Dashboard/Pages/Pricing.vue"),
        //     meta: { title: 'Cennik' }
        // },
        // {
        //     path: "/lock",
        //     name: "Lock",
        //     component: () =>
        //         import ( /* webpackChunkName: "lock" */ "@/pages/Dashboard/Pages/Lock.vue")
        // }
    ]
};

const routes = [{
        path: "/",
        redirect: "/dashboard",
        name: "Home"
    },
    examplesMenu,
    pagesMenu,
    customersMenu,
    locationsMenu,
    // licencesMenu,
    devicesMenu,
    cashRegistersMenu,
    peopleMenu,
    servicesMenu,
    DeviceModelFirmwareVersionsMenu,
    DeviceFirmwareVersionsMenu,
    DeviceModelsMenu,
    personalTokensMenu,
    authPages,
    {
        path: "/",
        component: DashboardLayout,
        meta: { middleware: auth },
        children: [{
                path: "dashboard",
                name: "Dashboard",
                component: () =>
                    import ( /* webpackChunkName: "dashboard" */ "@/pages/Dashboard/Dashboard.vue"),
                meta: { middleware: auth, title: 'Strona główna' }
            },
            {
                path: "404",
                name: "NotFound",
                component: () =>
                    import ( /* webpackChunkName: "not-found" */ "@/pages/Dashboard/NotFoundPage.vue"),
                meta: { middleware: auth, title: 'Strona nie istnieje' }
            },
            {
                path: "unauthorized",
                name: "Unauthorized",
                component: () =>
                    import( /* webpackChunkName: "unauthorized" */ "@/pages/Errors/Unauthorized.vue"),
                meta: { title: "Brak uprawnień" }
            },
            // {
            //     path: "blik-bm",
            //     name: "BLIK BM",
            //     component: () =>
            //         import ( /* webpackChunkName: "blik-bm" */ "@/pages/Dashboard/BlikBlueMedia.vue"),
            //     meta: { middleware: auth, title: 'BLIK Blue Media' }
            // },
            {
                path: "blik",
                name: "Blik",
                component: () =>
                    import ( /* webpackChunkName: "blik" */ "@/pages/Dashboard/Blik.vue"),
                meta: { middleware: auth, title: 'BLIK' }
            },
            {
                path: "blik-return/:id",
                name: "Blik Powrót ID",
                component: () =>
                    import ( /* webpackChunkName: "blik-return-id" */ "@/pages/Dashboard/BlikReturn.vue"),
                meta: { middleware: auth, title: 'BLIK Powrót' }
            },
            {
                path: "blik-return",
                name: "Blik Powrót",
                component: () =>
                    import ( /* webpackChunkName: "blik-return" */ "@/pages/Dashboard/BlikReturn.vue"),
                meta: { middleware: auth, title: 'BLIK Powrót' }
            },
            {
                path: "user-profile",
                name: "User Profile",
                component: () =>
                    import ( /* webpackChunkName: "user-profile" */ "@/pages/Dashboard/MyProfile/UserProfile.vue"),
                meta: { middleware: auth, title: 'Mój profil' }
            },
            {
                path: "customer-profile",
                name: "Customer Profile",
                component: () =>
                    import ( /* webpackChunkName: "customer-profile" */ "@/pages/Dashboard/MyProfile/CustomerProfile.vue"),
                meta: { middleware: auth, title: 'Dane firmy' }
            },
            {
                path: "administration/terminal-replacement",
                name: "Terminal Replacement",
                component: () =>
                    import ( /* webpackChunkName: "terminal-replacement" */ "@/pages/Dashboard/TerminalReplacementPage.vue"),
                meta: { middleware: auth, title: 'Wymiana terminala' }
            },
            {
                path: "administration/cash-register-services",
                name: "List Cash Register Services",
                component: () =>
                    import ( /* webpackChunkName: "cash-register-services" */ "@/pages/Dashboard/CashRegisterServices/ListCashRegisterServicePage.vue"),
                meta: { middleware: auth, title: 'Kasy fiskalne - usługi' }
            }
        ]
    }
];

export default routes;